import { render, staticRenderFns } from "./TariffFullBurn.vue?vue&type=template&id=5688d2e0&scoped=true&"
import script from "./TariffFullBurn.vue?vue&type=script&lang=js&"
export * from "./TariffFullBurn.vue?vue&type=script&lang=js&"
import style0 from "./TariffFullBurn.vue?vue&type=style&index=0&id=5688d2e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5688d2e0",
  null
  
)

export default component.exports